import { TimePeriod } from '~/Api/User/ExchangeRate';
import CustomRates from '~/Api/User/ProductGroup/ExchangeRatesSettings/CustomRates';

export default class RatesSettings {
	constructor(
		public readonly type: string,
		public readonly name: string,
		public readonly date: Date | null,
		public readonly customExchangeRates: CustomRates | null,
		public readonly timePeriod: TimePeriod
	) {}
}
